import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eca731b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "row space-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "red-bg bt" }, "Discard", -1))
const _hoisted_5 = { class: "text-editor" }

import RichTextBox from "@/components/RichTextBox.vue";
import { TeamStory } from "@/services/entities/teamStory";
import { useTeamStoryStore } from "@/stores/teamStory";
import { onMounted, reactive } from "vue";
import { onBeforeRouteLeave } from "vue-router";
import { getQueryParamByName } from "@/common/util";
import router from "@/router";
import { useTeamStore } from "@/stores/team";
import { toast } from "vue3-toastify";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateView',
  props: {
    template: {}
  },
  setup(__props: any) {

const teamStoryStore = useTeamStoryStore();
const teamStore = useTeamStore();

const props = __props;

onMounted(async () => {
    await teamStoryStore.loadTemplate(props.template);
    state.title = teamStoryStore.getTemplate?.heading ?? "";
    state.value = teamStoryStore.getTemplate?.body ?? "";
});

const state = reactive({
    value: "",
    title: "",
    saved: false
});

async function save() {
    let story = {
        heading: state.title,
        body: state.value,     
        tags: teamStoryStore.getTemplate.tags,   
    } as any as TeamStory;
    const t = toast.loading("Saving...");

    await teamStoryStore.createTeamStory(props.template, story);

    state.saved = true;
    toast.remove(t);
    toast.success("Saved!");
    setTimeout(() => {
        router.push({ name: 'Home' });
    }, 1000);
}

onBeforeRouteLeave((to, from, next) => {
    if (!state.saved && !confirm('Discard changes?')) {
        next(false);
    } else {
        next();
    }
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_unref(teamStore).getTeamName), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          id: "title",
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.title) = $event)),
          placeholder: "Choose a Title"
        }, null, 512), [
          [_vModelText, state.title]
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, { to: { name: 'Home' } }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("button", { onClickOnce: save }, "Save", 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(RichTextBox, {
        modelValue: state.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.value) = $event))
      }, null, 8, ["modelValue"])
    ])
  ]))
}
}

})